import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, Validators} from '@angular/forms';
import {HealthInsuranceService} from '../../services/health-insurance.service';
import {Response} from '../../model/GeneralModels';

@Component({
  selector: 'app-height-weight',
  template: `
    <div mat-dialog-content>
      <form [formGroup]="form">
        <app-input-field [fieldLabel]="'قد'"
                        [fieldName]="'height'"
                        [Group]="form"
                         [dataType]="['number']"
        ></app-input-field>
        <app-input-field [fieldLabel]="'وزن'"
                        [fieldName]="'weight'"
                        [Group]="form"
                        [dataType]="['number']"
        ></app-input-field>
      </form>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">لغو</button>
      <button mat-button (click)="submit()" cdkFocusInitial [disabled]="!form.valid">تایید</button>
    </div>
  `,
  styles: [`
    .mat-dialog-container {
      direction: rtl;
    }
  `]
})
export class HeightWeightComponent implements OnInit {
  form = this.fb.group({
    weight: ['', Validators.required],
    height: ['', Validators.required],
    subRequestID: [this.data.subRequestID, Validators.required]
  });
  result = false;

  ngOnInit(): void {
    console.log(this.data.subRequestID);
  }

  constructor(
    public dialogRef: MatDialogRef<HeightWeightComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private service: HealthInsuranceService) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit() {
    this.service.submitInfo(this.form.value).subscribe((response: Response) => {
      if (response.success) {
        this.dialogRef.close(true);
      }
    });
  }
}
